import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';

import { CatalogoTipoParticipacionDTO } from 'src/app/core/models/persona/interfaces';

import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlPersona;

@Injectable()
export class CatalogoTipoParticipacionService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) { }

  getCatalogoTipoParticipacionService(): Observable<BodyListResponse<CatalogoTipoParticipacionDTO>> {
    return this.http.get<BodyListResponse<CatalogoTipoParticipacionDTO>>(API_URL + '/api/v1/catalogoTipoParticipacion/todos');
  }

  guardarCatalogoTipoParticipacionService(catalogoTipoParticipacionDTO: CatalogoTipoParticipacionDTO): Observable<BodyResponse<CatalogoTipoParticipacionDTO>> {
    return this.http.post<BodyResponse<CatalogoTipoParticipacionDTO>>(API_URL + '/api/v1/catalogoTipoParticipacion', catalogoTipoParticipacionDTO);
  }

  getCatalogoTipoParticipacionPorCodigoTipoParticipacionService(codigoTipoParticipacion: string): Observable<BodyResponse<CatalogoTipoParticipacionDTO>> {
    return this.http.get<BodyResponse<CatalogoTipoParticipacionDTO>>(API_URL + '/api/v1/catalogoTipoParticipacion/' + codigoTipoParticipacion);
  }
}
